import { render } from "./cdrBatchAllocation.vue?vue&type=template&id=74a33668&scoped=true"
import script from "./cdrBatchAllocation.vue?vue&type=script&lang=js"
export * from "./cdrBatchAllocation.vue?vue&type=script&lang=js"

import "./cdrBatchAllocation.vue?vue&type=style&index=0&id=74a33668&scoped=true&lang=css"
import "./cdrBatchAllocation.vue?vue&type=style&index=1&id=74a33668&lang=css"
script.render = render
script.__scopeId = "data-v-74a33668"

export default script